import { IEvent } from '@/types/event'
import { ApiService } from './ApiService'

export type IEventPayload = IEvent

export class EventService extends ApiService {
  static POST_PATH = '/events'

  static async postEvent(payload: IEventPayload) {
    return ApiService.post(
      EventService.POST_PATH,
      {
        name: payload.name,
        data: payload.data,
      },
      { plain: true }
    )
  }
}
